<template>
  <div>
    <details-modal
      :show="show"
      current-operation="create"
      @close="closeModal"
      @cancel="closeModal"
      @create="institutionButtonClicked"
    >
      <form id="addInstitutionForm">
        <div class="row form-group2">
          <institution-select
            v-validate="'required'"
            v-model="institutionId"
            placeholder="Ajoutez une institution"
            data-vv-scope="formAddInstitution"
            name="institution"
            required
          />
        </div>
        <div v-if="errors.items.length" class="validation-error">
          {{ errors.first(`formAddInstitution.institution`) }}
        </div>
        <div class="row mt-4 text-left">
          <p-checkbox v-model="isContactPerson" inline>
            <div>
              la personne courante est la personne de contact de cette
              institution
            </div>
          </p-checkbox>
        </div>
      </form>
      <p v-if="errorMessage" class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
  </div>
</template>

<script>
import PCheckbox from 'src/components/UIComponents/Inputs/Checkbox.vue';
import InstitutionSelect from 'src/components/ApplicationViews/UIComponents/InstitutionSelect';
import DetailsModal from './DetailsModal.vue';

export default {
  components: {
    PCheckbox,
    InstitutionSelect,
    DetailsModal,
  },
  props: {
    show: Boolean,
    personId: Number,
  },
  data() {
    return {
      institutionId: null,
      isContactPerson: false,
      errorMessage: '',
    };
  },
  methods: {
    institutionButtonClicked() {
      // Validate that the required field are filled before creating record
      this.$validator.validateAll('formAddInstitution').then(result => {
        if (result) {
          this.errorMessage = null;

          this.$http
            .post(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/people/${this.personId}/institutions`,
              {
                institutionId: this.institutionId,
                isContactPerson: this.isContactPerson,
              },
            )
            .then(response => {
              this.closeModal();
            })
            .catch(error => {
              if (error.response.status === 409) {
                this.errorMessage =
                  'La personne est déjà associé à cette institution.';
              } else {
                this.errorMessage =
                  "Une erreur est survenue l'association de la personne à l'institution, veuillez réessayer ou contacter le support.";
              }
            });
        } else {
          this.errorMessage = 'Veuillez corriger les erreurs.';
        }
      });
    },
    closeModal() {
      this.$emit('close');
      this.errorMessage = '';
      this.institutionId = null;
      this.isContactPerson = false;
      document.getElementById('addInstitutionForm').reset();
    },
  },
};
</script>

<style scoped>
.validation-error {
  color: red;
  margin-bottom: 1em;
}
</style>
